import { IoSunny, IoMoon, IoPhonePortrait, IoCheckmark } from "react-icons/io5";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useTheme } from "@/theme";
import { useI18n } from "@/i18n";

export const ThemeDialog = ({ open, onOpenChange }) => {
  const { t } = useI18n();
  const { theme, setTheme } = useTheme();
  const options = [
    { id: "auto", label: t("theme_auto"), Icon: IoPhonePortrait },
    { id: "light", label: t("theme_light"), Icon: IoSunny },
    { id: "dark", label: t("theme_dark"), Icon: IoMoon },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="theme-dialog" className="max-w-sm p-0" style={{ borderRadius: 20 }}>
        <div className="tf-modal-content" style={{ paddingBottom: 12 }}>
          <div className="tf-modal-title">{t("theme_switch_title")}</div>
        </div>
        <div style={{ padding: "0 16px 20px", display: "flex", flexDirection: "column", gap: 8 }}>
          {options.map(({ id, label, Icon }) => (
            <button
              key={id}
              data-testid={`theme-option-${id}`}
              className="tf-theme-option"
              onClick={() => { setTheme(id); onOpenChange(false); }}
            >
              <span className="tf-theme-option-icon"><Icon size={20} /></span>
              <span className="tf-theme-option-label">{label}</span>
              {theme === id && <IoCheckmark size={22} color="#E2001A" />}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
